/**
 * Configure the http library for all api calls in the app
 * @author      Jeff Adams <jeff@tinyfly.com>
 * @copyright   Traxo, Inc. 2019
 */

import axios from 'axios';
import { RequestManager } from '@/utils/request-manager.js';

const requestManager = new RequestManager();

// Create an Axios instance to use in our app. This library automatically handles sending the
// CSRF token as a header based on the value of the "XSRF" token cookie.
const http = axios.create({
  // Let Laravel know that every Axios request is a xhr request
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
  // Custom config property to handle canceling pending xhr requests.
  cancelable: false,
});

requestManager.patch(http);

// All http calls in our app should use this axios instance
export { http };
